import api from "@/lib/api";

function hHeader() {
  const hid = (typeof document !== "undefined" ? document.cookie
    .split(";").map(c => c.trim()).find(c => c.startsWith("active_hotel_id=")) : null);
  const val = hid ? decodeURIComponent(hid.split("=")[1]) : null;
  return val ? { "X-Hocp-Hotel": val } : {};
}
const H = () => ({ headers: hHeader() });

export const supAPI = {
  dashboard:     ()             => api.get("/sup/v1/dashboard", H()).then(r => r.data),
  // Config
  config:        ()             => api.get("/sup/v1/config", H()).then(r => r.data),
  updateConfig:  (body)         => api.patch("/sup/v1/config", body, H()).then(r => r.data),
  setEnabledCategories: (codes) => api.put("/sup/v1/config/enabled-categories", codes, H()).then(r => r.data),
  // Categories
  categories:    (params = {})  => api.get("/sup/v1/categories", { ...H(), params }).then(r => r.data),
  createCategory:(body)         => api.post("/sup/v1/categories", body, H()).then(r => r.data),
  updateCategory:(id, body)     => api.patch(`/sup/v1/categories/${id}`, body, H()).then(r => r.data),
  // Vendors
  vendors:       (params = {})  => api.get("/sup/v1/vendors", { ...H(), params }).then(r => r.data),
  createVendor:  (body)         => api.post("/sup/v1/vendors", body, H()).then(r => r.data),
  updateVendor:  (id, body)     => api.patch(`/sup/v1/vendors/${id}`, body, H()).then(r => r.data),
  // Stores
  stores:        (params = {})  => api.get("/sup/v1/stores", { ...H(), params }).then(r => r.data),
  createStore:   (body)         => api.post("/sup/v1/stores", body, H()).then(r => r.data),
  updateStore:   (id, body)     => api.patch(`/sup/v1/stores/${id}`, body, H()).then(r => r.data),
  // Items
  items:         (params = {})  => api.get("/sup/v1/items", { ...H(), params }).then(r => r.data),
  createItem:    (body)         => api.post("/sup/v1/items", body, H()).then(r => r.data),
  updateItem:    (id, body)     => api.patch(`/sup/v1/items/${id}`, body, H()).then(r => r.data),
  // Stock
  stockSnapshot: (params = {})  => api.get("/sup/v1/stock/snapshot", { ...H(), params }).then(r => r.data),
  stockLedger:   (params = {})  => api.get("/sup/v1/stock/ledger", { ...H(), params }).then(r => r.data),
  stockAdjust:   (body)         => api.post("/sup/v1/stock/adjust", body, H()).then(r => r.data),
  stockTransfer: (body)         => api.post("/sup/v1/stock/transfer", body, H()).then(r => r.data),
  // PR
  prs:           (params = {})  => api.get("/sup/v1/prs", { ...H(), params }).then(r => r.data),
  pr:            (id)           => api.get(`/sup/v1/prs/${id}`, H()).then(r => r.data),
  createPR:      (body)         => api.post("/sup/v1/prs", body, H()).then(r => r.data),
  approvePR:     (id, body={})  => api.post(`/sup/v1/prs/${id}/approve`, body, H()).then(r => r.data),
  rejectPR:      (id, body)     => api.post(`/sup/v1/prs/${id}/reject`, body, H()).then(r => r.data),
  cancelPR:      (id)           => api.post(`/sup/v1/prs/${id}/cancel`, {}, H()).then(r => r.data),
  // PO
  pos:           (params = {})  => api.get("/sup/v1/pos", { ...H(), params }).then(r => r.data),
  po:            (id)           => api.get(`/sup/v1/pos/${id}`, H()).then(r => r.data),
  createPO:      (body)         => api.post("/sup/v1/pos", body, H()).then(r => r.data),
  cancelPO:      (id)           => api.post(`/sup/v1/pos/${id}/cancel`, {}, H()).then(r => r.data),
  // GRN
  grns:          (params = {})  => api.get("/sup/v1/grns", { ...H(), params }).then(r => r.data),
  createGRN:     (body)         => api.post("/sup/v1/grns", body, H()).then(r => r.data),
};

export const fmtINR = (n) => "₹" + (Number(n) || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
